import React from 'react';
import { Drawer } from 'vaul';
import { Check } from 'lucide-react';

export default function MobileSelectSheet({ 
  open, 
  onOpenChange, 
  value, 
  onValueChange, 
  options = [], 
  label,
  placeholder = 'Sélectionner'
}) {
  const selectedOption = options.find(opt => opt.value === value);

  return (
    <>
      {/* Trigger button */}
      <button
        onClick={() => onOpenChange(true)}
        className="w-full px-3 py-2 border border-[#2A2D3A] bg-[#13151D] rounded-md text-left text-sm text-white hover:bg-[#1B1E28] transition-colors"
      >
        {selectedOption?.label || placeholder}
      </button>

      {/* Bottom Sheet */}
      <Drawer.Root open={open} onOpenChange={onOpenChange}>
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/60 z-50" />
          <Drawer.Content 
            className="fixed bottom-0 left-0 right-0 z-50 bg-[#0B0D12] rounded-t-3xl border-t-2 border-[#6E2BFF] outline-none"
            style={{
              paddingBottom: 'env(safe-area-inset-bottom)'
            }}
          >
            <div className="mx-auto w-12 h-1.5 bg-[#2A2D3A] rounded-full mt-3 mb-4" />
            
            {label && (
              <div className="px-6 pb-3">
                <h3 className="text-white font-bold text-base">{label}</h3>
              </div>
            )}

            <div className="max-h-[60vh] overflow-y-auto px-4 pb-4">
              {options.map((option) => {
                const isSelected = value === option.value;
                return (
                  <button
                    key={option.value}
                    onClick={() => {
                      onValueChange(option.value);
                      onOpenChange(false);
                    }}
                    className={`
                      w-full flex items-center justify-between px-4 py-3 rounded-lg mb-2
                      transition-all
                      ${isSelected 
                        ? 'bg-[#6E2BFF] text-white' 
                        : 'bg-[#13151D] text-[#B3B6C2] hover:bg-[#1B1E28]'
                      }
                    `}
                  >
                    <span className="font-medium">{option.label}</span>
                    {isSelected && <Check className="w-5 h-5" />}
                  </button>
                );
              })}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </>
  );
}